import { css } from "aphrodite";
import styles from "./styles";
import {Input, MenuItem, Select, Typography} from "@mui/material";
import React, {useEffect, useRef} from "react";
import Logger from "../../../../Utils/Logger";
import countryCodes from "../../../../Utils/CountryCodes";

const PhoneNumberInputSelect = ({
    field,
    label,
    name,
    id,
    value,
    onBlur,
    verticalMode = true,
    hideErrorMessage = false,
    form: { touched, errors },
    ...props
  }) => {
    const [countryCode, setCountryCode] = React.useState('+30');
    const [phoneNumber, setPhoneNumber] = React.useState('');
    const inputRef = useRef(null);
    const [uniqueCountryCodes, setUniqueCountryCodes] = React.useState([])

    useEffect(() => {
        setUniqueCountryCodes([...new Set(countryCodes.map(cc => cc.dial_code))])
    }, []);

    const handleBlur = (e) => {
        if (onBlur && typeof onBlur === 'function') {
            onBlur(e)
        }
    }

    const handleInputChange = (event) => {
      try {
          const value = String(event.target.value || '');
          event.target.value = countryCode + value
          if (props.onChange && typeof props.onChange === 'function') {
              props.onChange(event)
          }
          setPhoneNumber(value)
      } catch (e) {
          Logger.log("PhoneNumberInputSelect@handleInputChange Exception", e)
      }
    }
    const handleSelectChange = (event) => {
        try {
            const value = String(event.target.value || '');
            event.target.value = value + phoneNumber
            if (props.onChange && typeof props.onChange === 'function') {
                props.onChange(event)
            }
            setCountryCode(value)
        } catch (e) {
            Logger.log("PhoneNumberInputSelect@handleSelectChange Exception", e)
        }
    }

    return (
      <div className={css([styles.container, (!verticalMode) && styles.rowButton])}>
        <div className={css(
            styles.inputContainer,
            (touched[field.name] && errors[field.name]) && styles.error
            )}>
            <Select
                // labelId="demo-simple-select-label"
                variant={'standard'}
                // id="demo-simple-select"
                // value={age}
                // label="Age"
                // onChange={handleChange}
                name={field.name}
                onBlur={handleBlur}
                sx={{
                    borderBottom: 'none',
                    marginTop: '0 !important',
                    height: '100% !important'
                }}
                disableUnderline={true}

                value={countryCode}
                onChange={handleSelectChange}
            >
                {uniqueCountryCodes.map((cc, index) => (
                    <MenuItem key={index} value={cc}>{cc}</MenuItem>

                ))}
            </Select>
          <Input
              ref={inputRef}
            fullWidth
            disableUnderline={true}
            id={id}
            type="text"
            name={field.name}
            onBlur={handleBlur}
            value={phoneNumber}
            onChange={handleInputChange}
            placeholder={props.placeholder || 'XXXXX'}
          />
        </div>
        {!hideErrorMessage &&
          (
            <>
              {touched[field.name] && errors[field.name] && (
                  <div className={css(styles.errorField)}>
                    <Typography className={css(styles.error)} variant="subtitle2">
                        {errors[field.name]}
                    </Typography>
                  </div>
              )}
            </>
          )
        }
      </div>
    );
  };

export default PhoneNumberInputSelect;
